// extracted by mini-css-extract-plugin
module.exports = {"opcoes":"Opcoes_opcoes__3oAT9","card":"Opcoes_card__lj8QL"};